import { useContext, useEffect, useState } from "react";
import "./StakeMuscleX.css";
import NftItemPreview from "../../components/NftItemPreview";
import { AppContext } from "../../context/main";
import { getNFTDataStaked, getNFTsinUserWallet } from "../../moralis/main";
import {
  nftContract,
  NFTContractAddress,
  nftStakingContract,
  StakingContractAddress,
} from "../../config/main2.config";
import { IoIosArrowBack } from "react-icons/io";
import { ethers } from "ethers";
import Loader from "../../components/Loader";
import { checkGroupId } from "../../utils/muscleXnft";
import { getAllGroupRate, getStakingDays } from "../../contractCalls/main2";

const StakeMuscleX = () => {
  const stakingMenu = ["NFTs in Wallet", "NFTs Staked"];

  const [currentMenuIndex, setCurrentMenuIndex] = useState(0);

  const { userWalletAddress, isUserConnected } = useContext(AppContext);

  const [viewSingleNFTData, setViewSingleNFTData] = useState(false);

  const [nftDataSelected, setNFTDataSelected] = useState({});

  const [allNFTsInWallet, setAllNFTsInWallet] = useState([]);

  const [hasUserApprovedNFT, setHasUserApprovedNFT] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [nftIdsStaked, setNFTIdsStaked] = useState([]);

  const [nftRewardRates, setNFTRewardRate] = useState({});

  const [nftDataStaked, setNFTDataStaked] = useState([]);

  const [stakingDays, setStakingDays] = useState(0);

  const [nftBeingUnStaked, setNFTBeingUnstaked] = useState(0);

  const handleGetNFTsInWallet = async () => {
    const nftsInWallet = await getNFTsinUserWallet(
      userWalletAddress,
      NFTContractAddress
    );
    const nftsThatCanBesStaked = nftsInWallet.filter((eachNFT) => {
      const groupId = checkGroupId(parseInt(eachNFT.token_id));
      const canNFTStake =
        groupId === 5
          ? true
          : groupId === 3
          ? true
          : groupId === 4
          ? true
          : false;
      return canNFTStake;
    });
    console.log(nftsInWallet, "inWallet", nftsThatCanBesStaked, "can Stake");
    setAllNFTsInWallet(nftsThatCanBesStaked);
  };

  const handleGetStakingDays = async () => {
    const stakingDays = await getStakingDays();
    setStakingDays(stakingDays);
  };

  const handleGetNFTDataStaked = async (arrayOfNFTIds) => {
    const nftData = await getNFTDataStaked(arrayOfNFTIds, 2);
    console.log(nftData, "nfts");
    setNFTDataStaked(nftData);
  };

  const getNFTsStakedByUser = async (userAddress) => {
    const nftsStaked = await nftStakingContract.checkUserNftStaked(userAddress);
    console.log(nftsStaked, "nftstaked");
    setNFTIdsStaked(nftsStaked);
    const arrayOfNftStakedIds = nftsStaked.map((nftId) => nftId.toString());
    handleGetNFTDataStaked(arrayOfNftStakedIds);
  };

  const handleGetNFTRewardRates = async () => {
    const ratesData = await getAllGroupRate();
    console.log(ratesData, "rates");

    setNFTRewardRate(ratesData);
  };

  useEffect(() => {
    if (isUserConnected) {
      handleGetNFTsInWallet();
      getNFTsStakedByUser(userWalletAddress);
    }
    handleGetNFTRewardRates();
    handleGetStakingDays();
  }, [isUserConnected, userWalletAddress]);

  const checkContractApproval = async (tokenId) => {
    console.log(nftContract);
    const addressApproved = await nftContract.getApproved(tokenId);
    console.log(addressApproved);
    const isStakingContractApproved =
      addressApproved === StakingContractAddress;
    setHasUserApprovedNFT(isStakingContractApproved);
  };

  const handleApproveNFT = async (tokenId) => {
    setIsLoading(true);
    try {
      const approveTransaction = await nftContract.approve(
        StakingContractAddress,
        tokenId
      );
      await approveTransaction.wait();
      checkContractApproval(tokenId);
      alert("Approved Token to Staking Contract");
      setHasUserApprovedNFT(true);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  const stakeNFT = async (tokenId, rewardWithBNB) => {
    const groupId = checkGroupId(parseInt(tokenId));
    const canNFTStake =
      groupId === 5
        ? true
        : groupId === 3
        ? true
        : groupId === 4
        ? true
        : false;
    if (canNFTStake) {
      setIsLoading(true);
      try {
        const stakeNFT = await nftStakingContract.stakeNft(
          tokenId.toString(),
          stakingDays,
          rewardWithBNB
        );
        await stakeNFT.wait();
        alert("NFT Staked");
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        alert("An error occured");
        setIsLoading(false);
      }
    } else {
      alert("This NFT Can't be Staked");
    }
  };

  const unStakeAndClaimRewards = async (tokenId) => {
    console.log(tokenId);
    setNFTBeingUnstaked(tokenId);
    setIsLoading(true);
    try {
      const unstakeNft = await nftStakingContract.UnstakeAndClaimRewards(
        tokenId
      );
      await unstakeNft.wait();
      setIsLoading(false);
      alert("NFT Successfully Unstaked & Rewards Claimed Automatically");
      setNFTBeingUnstaked(0);
    } catch (e) {
      console.log(e);
      alert("Something Went wrong");
      setIsLoading(false);
      setNFTBeingUnstaked(0);
    }
  };

  const handleEmergencyUnstake = async (tokenId) => {
    console.log(tokenId);
    setNFTBeingUnstaked(tokenId);
    setIsLoading(true);
    try {
      const emergencyUnstake = await nftStakingContract.EmergencyUnstake(
        tokenId
      );
      await emergencyUnstake.wait();
      setIsLoading(false);
      alert("NFT Successfully Unstaked  on Emergency ");
      setNFTBeingUnstaked(0);
    } catch (error) {
      console.log(error);
      alert("Something Went wrong");
      setIsLoading(false);
      setNFTBeingUnstaked(0);
    }
  };

  return (
    <div className="homePage_Main">
      <h1>Muscle X NFT Staking Platform</h1>
      <br />
      <p>Stake your Muscle X NFT Nfts here ( X, CaptainX, and BatX )</p>

      <br />
      {nftRewardRates["5"] !== undefined ? (
        <div style={{ justifyItems: "flex-start" }}>
          <p>
            X Reward Rate (BNB) : {nftRewardRates["5"].bnb} BNB / Month / NFT
            Staked{" "}
          </p>
          <p>
            X Reward Rate (MuscleX Token) : {nftRewardRates["5"].token} MuscleX
            Token / Month / NFT Staked{" "}
          </p>
          <p>
            BatX Reward Rate (BNB): {nftRewardRates["4"].bnb} BNB / Month / NFT
            Staked{" "}
          </p>
          <p>
            BatX Reward Rate (MuscleX Token): {nftRewardRates["4"].token}{" "}
            MuscleX Token / Month / NFT Staked{" "}
          </p>
          <p>
            CaptainX Reward Rate (BNB): {nftRewardRates["3"].bnb} BNB / Month /
            NFT Staked{" "}
          </p>
          <p>
            CaptainX Reward Rate (MuscleX Token): {nftRewardRates["3"].token}{" "}
            MuscleX Token / Month / NFT Staked{" "}
          </p>
        </div>
      ) : (
        ""
      )}
      <br />
      <br />

      <div className="stakingSection">
        {viewSingleNFTData === false ? (
          <div className="menuSection">
            {stakingMenu.map((eachMenu, index) => {
              return (
                <div
                  className="menuBox"
                  key={index}
                  onClick={() => {
                    setCurrentMenuIndex(index);
                    if (index === 1) {
                      getNFTsStakedByUser(userWalletAddress);
                    }
                  }}
                >
                  <p>{eachMenu}</p>
                  <div
                    className={
                      currentMenuIndex === index
                        ? "horizontalBarActive"
                        : "horizontalBar"
                    }
                  >
                    {" "}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}

        <br />
        <br />

        <div className="list_nft_section">
          {allNFTsInWallet.length > 0 &&
          currentMenuIndex === 0 &&
          viewSingleNFTData === false
            ? allNFTsInWallet.map((eachNFT, index) => {
                return (
                  <NftItemPreview
                    actionText={"Select for Staking"}
                    isNFTStaked={false}
                    nftData={eachNFT.metadata}
                    key={index}
                    handleSelectNFTForStaking={() => {
                      console.log(eachNFT);
                      setNFTDataSelected(eachNFT);
                      setViewSingleNFTData(true);
                      checkContractApproval(eachNFT.token_id);
                    }}
                    isNFTSelected={false}
                  />
                );
              })
            : ""}
        </div>
        <div className="list_nft_section">
          {nftDataStaked.length > 0 &&
          currentMenuIndex === 1 &&
          viewSingleNFTData === false
            ? nftDataStaked.map((eachNFT, index) => {
                return (
                  <div key={index}>
                     
                    <NftItemPreview
                      actionText={"Claim Reward & Unstake"}
                      isNFTStaked={true}
                      nftData={eachNFT.metaData}
                      key={index}
                      handleUnstakeNFT={() => {
                        unStakeAndClaimRewards(eachNFT.tokenId);
                      }}
                      isNFTSelected={false}
                    />
                    <br />
                    <br />
                    <div className="actionButtonsSection">
                      <button
                        onClick={() => {
                          handleEmergencyUnstake(eachNFT.tokenId);
                        }}
                      >
                        Emergency Unstake
                      </button>
                    </div>
                    <p>Rewards so far : {eachNFT.rewards} </p>
                    {isLoading && nftBeingUnStaked === eachNFT.tokenId ? (
                      <Loader />
                    ) : (
                      ""
                    )}
                  </div>
                );
              })
            : ""}
        </div>
        {viewSingleNFTData ? (
          <>
            <div className="singleNFTView">
              <IoIosArrowBack
                size={30}
                color={"black"}
                onClick={() => {
                  setViewSingleNFTData(false);
                  setNFTDataSelected({});
                  setHasUserApprovedNFT(false);
                }}
              />
              <NftItemPreview
                actionText={""}
                isNFTStaked={false}
                isNFTSelected={true}
                nftData={nftDataSelected.metadata}
              />
            </div>
            <br />
            <br />
            <p style={{ textAlign: "center" }}>
              Staking Reward :{" "}
              {nftRewardRates[checkGroupId(nftDataSelected.token_id)].bnb} BNB /
              Month{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Staking Reward :{" "}
              {nftRewardRates[checkGroupId(nftDataSelected.token_id)].token}{" "}
              MuscleX Token / Month{" "}
            </p>
            <br />
            <br />
            <div className="actionButtonsSection">
              {hasUserApprovedNFT === false ? (
                <button
                  onClick={() => {
                    handleApproveNFT(nftDataSelected.token_id);
                  }}
                >
                  Approve
                </button>
              ) : (
                ""
              )}

              <button
                onClick={() => {
                  stakeNFT(nftDataSelected.token_id, true);
                }}
              >
                Stake NFT (BNB Reward)
              </button>
              <button
                onClick={() => {
                  stakeNFT(nftDataSelected.token_id, false);
                }}
              >
                Stake NFT (MuscleX Token Reward )
              </button>
            </div>
            {isLoading ? <Loader /> : ""}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default StakeMuscleX;
